angular.module('zc.zenclerkS')
  .controller('SetupUserController', SetupUserController);

SetupUserController.$inject = ['$state', 'Devise', 'currentUser'];
function SetupUserController($state, Devise, currentUser) {
  const vm = this;
  const pick = ['full_name', 'email', 'department', 'position', 'company_name'];

  vm.user = _.pick(currentUser, pick);
  vm.save = () => {
    Devise.updateInfo(
      _.pick(vm.user, pick)
    ).then( user => {
      $state.go('zenclerkS.home');
    });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/setup/setup_user.controller.js